<template>
  <el-container>
    <el-main>
      <span>{{ruleForm.id?'修改':'添加'}}配置</span>
      <el-button type="warning" size="mini" style="float: right" @click="returnBack">返回</el-button>
      <el-divider class="divider"></el-divider>
      <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="销售组织选择" label-width="260px" prop="adminOrgUnitId">
          <el-select v-model="ruleForm.adminOrgUnitId" placeholder="请选择销售组织" clearable>
            <el-option v-for="saleOrg in saleOrgLists" :label="saleOrg.name" :key="saleOrg.id" :value="saleOrg.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务员订货展示价格" label-width="260px" prop="isPricePer">
          <el-radio-group v-model="ruleForm.isPricePer">
            <el-radio :label=1>是</el-radio>
            <el-radio :label=0>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="客户订货展示价格" label-width="260px" prop="isPriceCus">
          <el-radio-group v-model="ruleForm.isPriceCus">
            <el-radio :label=1>是</el-radio>
            <el-radio :label=0>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="销量查询展示辅助数量" label-width="260px" prop="isShowAssist">
          <el-radio-group v-model="ruleForm.isShowAssist">
            <el-radio :label=1>是</el-radio>
            <el-radio :label=0>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="销量查询展示金额" label-width="260px" prop="isShowAmount">
          <el-radio-group v-model="ruleForm.isShowAmount">
            <el-radio :label=1>是</el-radio>
            <el-radio :label=0>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="订单天数（可查询几天前的订单）" label-width="260px" prop="orderDay">
          <el-input class="input" type="number" placeholder="请输入天数（整数）" v-model="ruleForm.orderDay"></el-input>
        </el-form-item>
        <el-form-item label="提货天数（可预约几天后的提货单）" label-width="260px" prop="deliveryDay">
          <el-input class="input" type="number" placeholder="请输入天数（整数）" v-model="ruleForm.deliveryDay"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -30%;text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import {mapGetters} from "vuex";
import {saveBasEbusiness, updateBasEbusiness} from "../../../../api/system/saleOrgConfig";
import {getOrgByAdmin} from "../../../../api/system/org_sale";

export default {
  name: "index",
  data() {
    return {
      ruleForm:{
        id:'',
        selectedSale:'',
        isPricePer: 0,
        isPriceCus: 0,
        isShowAssist: 0,
        isShowAmount: 0,
        orderDay: 0,
        deliveryDay: 0
      },
      saleOrgLists:[],
      loading:false,
      rules: {
        selectedSale: [
          { required: true, message: '请选择销售组织', trigger: 'blur' },
        ],
        isPricePer: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        isPriceCus: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        isShowAssist: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        isShowAmount: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        orderDay: [
          { required: true, message: '请输入订单天数', trigger: 'blur' }
        ],
        deliveryDay: [
          { required: true, message: '请输入提货天数', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.getOrgByAdmin();
    if(this.$route.params.saleOrgConfigList != null){
      this.ruleForm = JSON.parse(this.$route.params.saleOrgConfigList)
    }
  },
  methods:{
    getOrgByAdmin(){
      let param = {'id':this.currentUser.id}
      getOrgByAdmin(param).then(res => {
        console.log(res.data)
        this.saleOrgLists = res.data
        this.getList();
      }).catch(()=>{

      })
    },
    submitForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {}
          param.adminOrgUnitId = this.ruleForm.adminOrgUnitId
          param.isPricePer = this.ruleForm.isPricePer
          param.isPriceCus = this.ruleForm.isPriceCus
          param.isShowAssist = this.ruleForm.isShowAssist
          param.isShowAmount = this.ruleForm.isShowAmount
          param.orderDay = this.ruleForm.orderDay
          param.deliveryDay = this.ruleForm.deliveryDay
          console.log(param);
          console.log(this.ruleForm.id)
          if(this.ruleForm.id === ''){
            saveBasEbusiness(param).then(res => {
              if(res.code === 200){
                this.loading = false
                this.$message.success('保存成功');
                this.returnBack()
              }
            }).catch(()=>{
              this.loading = false
              this.$message.error('添加失败，请重试');
            })
          }else{
            param.id = this.ruleForm.id
            updateBasEbusiness(param).then(res => {
              if(res.code === 200){
                this.loading = false
                this.$message.success('保存成功');
                this.returnBack()
              }
            }).catch(()=>{
              this.loading = false
              this.$message.error('添加失败，请重试');
            })
          }
        }else{
          this.loading = false
          this.$message.error('添加失败，请重试');
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    returnBack(){
      this.$router.push({path: "/settings/saleOrgConfig/list"});
    }
  }
}
</script>

<style scoped>
  .divider{
    margin: 12px 0;
  }
  .form{
    margin-left: 30%;
    margin-top: 30px;
  }
  .input{
    width: 240px;
  }
</style>
